import axios from '../utils/axiosClient';
import endpoints from './endpoints';
import { PublishedTermsAndConditions, AcceptTermsAndConditionsRequest } from '../interfaces/termsAndConditions';

const { getPublishedTermsAndConditions, acceptTermsAndConditions } = endpoints;
const getPublishedTerms = async (): Promise<PublishedTermsAndConditions> => {
  try {
    const response = await axios.get(getPublishedTermsAndConditions);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const acceptTerms = async (termsId: string): Promise<void> => {
  try {
    const data: AcceptTermsAndConditionsRequest = { termsId };
    const response = await axios.post(acceptTermsAndConditions, data);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const termsAndConditionsService = {
  getPublishedTerms,
  acceptTerms,
};

export default termsAndConditionsService;
